import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    maxHeight: "100vh",
    backgroundColor: theme.palette.bg,
  },
  subRoot: {
    width: "4.4655%",
    backgroundColor: theme.palette.bg,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  main: {
    maxHeight: "100vh",
    height: "100vh",
    position: "relative",
    boxShadow: "4px 8px 16px rgb(0,0,0,.16)",
    overflow: "hidden",
    backgroundColor: theme.palette.bg,
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  mdAppIconMenu: {
    width: "65px",
    backgroundColor: theme.palette.toolBarBg,
    borderRight: "1px solid rgb(0,0,0,.1)",
    height: "80px",
    overflow: "scroll",
    position: "absolute",
    zIndex: 2,
    right: 0,
    top: 0,
  },
  fullAppIconMenu: {
    width: "4.4656%",
    backgroundColor: theme.palette.toolBarBg,
    borderRight: "1px solid rgb(0,0,0,.1)",
  },
}));

export default useStyles;
